import React, { useState } from "react";
import "./UserOrder.css";
import { Collapse } from 'react-collapse';
import config from '../../config.json';
import { priceFormat } from "../../util/showPriceFormat";
import { genSpecificDateTime } from "../../util/dateTime";

const UserOrder = ({ number, order }) => {
    const [collapse, setCollapse] = useState(false);


    return (
        <div className="user-order-layer rtl mx-auto">
            <section className="order-section">
                <div className="first alert alert-success ltr"># {order.factureNumber}</div>
                <div className="second d-none d-md-flex">{order.customer.name}</div>
                <div className="third ltr ms-auto">
                    {genSpecificDateTime(order.createdAt, 'jYYYY/jMM/jDD - HH:mm').dateTimeStr}
                </div>
                <div className="last">
                    <button className="btn btn-sm btn-success"
                        onClick={() => setCollapse(prev => !prev)}
                    ><i className={collapse ? 'fa fa-arrow-up' : 'fa fa-arrow-down'}></i></button>
                </div>
            </section>
            <div style={{ backgroundColor: 'red' }}>
            </div>
            <Collapse isOpened={collapse} >
                <div className="collapse-layer">
                    <table className="table table-bordered mb-0">
                        <tbody>
                            <tr>
                                <th>#</th>
                                <th style={{ textAlign: 'right' }}>محصول</th>
                                <th>تعداد / مقدار</th>
                                <th className="text-center">فی جزء</th>
                                <th className="text-end">قیمت</th>
                            </tr>
                            {
                                order.items.map((element, index) =>

                                    <tr key={element._id}>
                                        <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                        <td>{element.name}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {(element.unit === 'کیلو گرم' && element.count < 1) ? element.count * 1000 : element.count} {(element.unit === 'کیلو گرم' && element.count < 1) ? <small className="ms-1">گرم</small> : <small className="ms-1">{element.unit}</small>}
                                        </td>
                                        <td style={{ textAlign: 'left' }}>{priceFormat(element.price)} {config.currencyType}</td>
                                        <td style={{ textAlign: 'left' }}>{priceFormat(element.count * element.price)} {config.currencyType}</td>
                                    </tr>
                                )
                            }
                            {
                                Number(order.totalPrice) - Number(order.sumOfPrice) > 0 ?
                                    <React.Fragment>
                                        <tr >
                                            <td colSpan="5">
                                                <span >مجموع مبلغ</span>
                                                <span style={{ float: 'left' }}>{priceFormat(order.sumOfPrice)} {config.currencyType}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5">
                                                <span >مالیات بر ارزش افزوده</span>
                                                <span style={{ float: 'left' }}>{priceFormat(Number(order.totalPrice) - Number(order.sumOfPrice))}  {config.currencyType}</span>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                    : null
                            }
                            {
                                order.sendType &&
                                <tr className="fw-bold">
                                    <td colSpan="5" className="text-primary">
                                        <span ><i className="fa fa-envelope"></i> هزینه {order.sendType} {order.sendImmadiate ? <span className="text-danger">(ارسال فوری)</span> : ''}</span>
                                        <span style={{ float: 'left' }}>{order.sendCost ? `${priceFormat(order.sendCost)} ${config.currencyType}` : 'رایگان'}</span>
                                    </td>
                                </tr>
                            }
                            <tr className="fw-bold">
                                <td colSpan="5" >
                                    <span > قابل پرداخت</span>
                                    <span style={{ float: 'left' }}>{priceFormat(order.totalPrice)} {config.currencyType}</span>
                                </td>
                            </tr>
                            {
                                order.info &&
                                <tr style={{ padding: '5px' }}>
                                    <td colSpan="5" style={{ fontSize: '.9rem' }}>
                                        <span style={{ marginLeft: '3px', color: 'var(--bgWarning)' }}>توضیحات : </span>
                                        <span>
                                            {order.info}
                                        </span>

                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <div className=" d-flex">
                        {
                            order.editTimeStamp &&
                            <div className="mb-0 alert alert-warning p-1 mt-3" style={{ whiteSpace: 'nowrap', display: 'inline-block' }}>
                                <span style={{ fontStyle: 'italic' }}># ویرایش شده </span>
                                {/* <span className="ltr d-inline-block">{genSpecificDateTime(order.editTimeStamp, 'jYYYY/jMM/jDD - HH:mm').dateTimeStr}</span> */}
                            </div>
                        }

                    </div>
                    <div className=" mt-3 d-flex justify-content-between w-100 flex-wrap">
                        <div className="mb-1 col-12 col-sm-6 text-start"><span>شهر/منطقه : </span>{order.customer.areaName}</div>
                        <div className="mb-1 col-12 col-sm-6 text-start"><span>آدرس : </span>{order.customer.address}</div>
                    </div>
                </div>
            </Collapse>
        </div>
    );
};

export default UserOrder;
